import ApiService from "./api.service"
import {server,constant} from "./../core/data/config"

export const decreaseBetResponseService = {
    sendDecreaseBetResponse
}

function sendDecreaseBetResponse(): any {
    const randomVal = 0;
    let url = "";
    if (server.configGame.port === 0) {
       // url = server.configGame.endpoint + "action?token=" + localStorage.getItem("playerId");
        url = server.configGame.endpoint + "action?token=" + constant.configGame.playerId;
    } else {
      //  url = server.configGame.endpoint + ":" + server.configGame.port + "action?token=" + localStorage.getItem("playerId");
        url = server.configGame.endpoint + ":" + server.configGame.port + "action?token=" +  constant.configGame.playerId;

    }
    const api = new ApiService(url);
    const param = {
        "gameRequest": {cmd: "decreaseBet"}
    };
    if (server.configGame.method === "get") {
        return api.get(url, param);
    }
    if (server.configGame.method === "post") {

        return api.post(url, param);
    }
}
